import styled from "styled-components";

const CenteredColumn = styled.div`
  max-width: 1650px;
  margin: 0 auto;
  height: 100%;
`;

export default CenteredColumn;
